// Authentication service
import { apiRequest, setAuthToken, getAuthToken } from "./api";

export const authService = {
  login: async (email, password) => {
    const response = await apiRequest("/auth/login", {
      method: "POST",
      body: JSON.stringify({ email, password }),
    });

    if (response.token) {
      setAuthToken(response.token);
    }

    return response;
  },

  logout: () => {
    setAuthToken(null);
  },

  changePassword: async (currentPassword, newPassword) => {
    return await apiRequest("/auth/change-password", {
      method: "POST",
      requiresAuth: true,
      body: JSON.stringify({ currentPassword, newPassword }),
    });
  },

  isAuthenticated: () => {
    return !!getAuthToken();
  },

  getToken: () => {
    return getAuthToken();
  },
};
